import React from 'react';

import { Tooltip } from '@material-ui/core';

interface IProps {
  [key: string]: any;
  condition: boolean;
  title: string;
  children: React.ReactElement;
}

const ConditionalTooltip: React.FC<IProps> = ({ condition, title, children, ...childProps }) => {
  if (condition) {
    const child = React.Children.only(children);
    const childWithProps = React.cloneElement(child, childProps);
    return (
      <Tooltip arrow title={title}>
        {childWithProps}
      </Tooltip>
    );
  } else {
    return children;
  }
};

export default ConditionalTooltip;
